module.exports = __webpack_public_path__ + "static/media/Stochastic_Cellular.acb0152c.png";